var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "170px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "文章标题", prop: "newsTitle" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入文章标题",
                      maxlength: "50",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.newsTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "newsTitle", $$v)
                      },
                      expression: "form.newsTitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属比赛", prop: "contest" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择所属比赛" },
                      model: {
                        value: _vm.form.contest,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contest", $$v)
                        },
                        expression: "form.contest",
                      },
                    },
                    _vm._l(_vm.contestTypeList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "文章排序", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "10", "show-word-limit": "" },
                    on: {
                      input: function (e) {
                        return (_vm.form.sort = _vm.isnumber(e))
                      },
                    },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "层次", prop: "courseLevel" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择层次" },
                      model: {
                        value: _vm.form.courseLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "courseLevel", $$v)
                        },
                        expression: "form.courseLevel",
                      },
                    },
                    _vm._l(_vm.courseLevelList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "年份", prop: "year" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择年份" },
                      model: {
                        value: _vm.form.year,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "year", $$v)
                        },
                        expression: "form.year",
                      },
                    },
                    _vm._l(_vm.yearList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "比赛类型", prop: "contestType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择比赛类型" },
                      model: {
                        value: _vm.form.contestType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contestType", $$v)
                        },
                        expression: "form.contestType",
                      },
                    },
                    _vm._l(_vm.coTypeList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "启用外链",
                    "label-width": "120px",
                    prop: "enableNewsUrl",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.enableNewsUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "enableNewsUrl", $$v)
                        },
                        expression: "form.enableNewsUrl",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "外链", "label-width": "120px" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入外链" },
                    model: {
                      value: _vm.form.newsUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "newsUrl", $$v)
                      },
                      expression: "form.newsUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件", "label-width": "120px" } },
                [
                  _c("FileUpload", {
                    attrs: { title: "文件上传", accept: "" },
                    on: { successData: _vm.getUploadFileData },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.fileList, function (file, index) {
                    return _c("p", { key: index }, [
                      _vm._v(
                        "\n          " + _vm._s(file.fileName) + "\n          "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "el-icon-delete",
                          on: {
                            click: function ($event) {
                              return _vm.del(index)
                            },
                          },
                        },
                        [_vm._v("移除")]
                      ),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内容", "label-width": "120px" } },
                [
                  _c("Editor", {
                    ref: "child",
                    attrs: {
                      editorId: "editor",
                      editorContent: _vm.form.newsContent,
                    },
                    on: {
                      "update:editorContent": function ($event) {
                        return _vm.$set(_vm.form, "newsContent", $event)
                      },
                      "update:editor-content": function ($event) {
                        return _vm.$set(_vm.form, "newsContent", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.submit("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.isBack } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }